import { useQuery } from '@tanstack/react-query';
import useEmployeeNoticesT from '@/components/email-templates/useEmployeeNoticesT';
import { EMPLOYEE_EQUIPMENT_QUERY_KEY } from '@/components/email-templates/constants';
import { getEmployeeEquipment } from '@/services/equipmentRequests.service';
import { cn } from '@/libs/utils';
import { itemLabel } from './equipmentLines';

/**
 * "To be returned: Laptop, Access card" — the items the employee holds now,
 * shown on the termination. Nothing when there are none, or when the caller
 * may not see the employee's equipment (the server refuses; no retry).
 * With `hint`, also says the services get an email when it is saved.
 */
export default function EquipmentToReturn({ employeeId, hint = false, className }) {
  const { tn } = useEmployeeNoticesT();
  const { data } = useQuery({
    queryKey: [EMPLOYEE_EQUIPMENT_QUERY_KEY, employeeId],
    queryFn: () => getEmployeeEquipment(employeeId),
    enabled: Boolean(employeeId),
    retry: false,
  });
  const assigned = data?.assigned || [];
  if (!assigned.length) return null;

  return (
    <span className={cn('block text-[12px] text-amber-800', className)}>
      <span className="font-semibold">
        {tn('toReturn', { items: assigned.map(itemLabel).join(', ') })}
      </span>
      {hint && <span className="block text-zinc-600">{tn('toReturnHint')}</span>}
    </span>
  );
}
